import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface SocketStore {
  userQuery: Record<string, any>;
  webChatQuery: Record<string, any>;
  socketReady: boolean;
  socketSessionReady: boolean;

  setUserQuery: (query: Record<string, any>) => void;
  setWebChatQuery: (query: Record<string, any>) => void;
  setSocketReady: (socketReady: boolean) => void;
  setSocketSessionReady: (socketSessionReady: boolean) => void;
}

export const useSocketStore = create(
  devtools<SocketStore>((set, get) => ({
    userQuery: {},
    webChatQuery: {},
    socketReady: false,
    socketSessionReady: false,
    setUserQuery: (query) => set({ userQuery: query }),
    setWebChatQuery: (query) => set({ webChatQuery: query }),
    setSocketReady: (socketReady) => set({ socketReady }),
    setSocketSessionReady: (socketSessionReady) => set({ socketSessionReady }),
  }))
);
